var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M25.906,24.535,24.4,20.07a11.339,11.339,0,0,0,1.115-4.884,11.182,11.182,0,0,0-3.154-7.831A10.848,10.848,0,0,0,6.763,7.279a11.152,11.152,0,0,0-3.215,7.744,8.176,8.176,0,0,0-3.2,6.513,8.273,8.273,0,0,0,.772,3.476L.079,28.087a1.458,1.458,0,0,0,.341,1.5,1.4,1.4,0,0,0,1.474.346l3.027-1.057a7.932,7.932,0,0,0,3.421.785h.013a7.951,7.951,0,0,0,6.461-3.338,10.877,10.877,0,0,0,4.538-1.129l4.395,1.534a1.667,1.667,0,0,0,1.752-.412A1.733,1.733,0,0,0,25.906,24.535ZM8.355,28.087h-.01a6.391,6.391,0,0,1-3.006-.758.763.763,0,0,0-.613-.049l-3.1,1.084L2.688,25.21a.8.8,0,0,0-.048-.623,6.637,6.637,0,0,1,1.052-7.6,11.149,11.149,0,0,0,3.146,6.134A10.861,10.861,0,0,0,12.882,26.2,6.384,6.384,0,0,1,8.355,28.087ZM24.407,25.2a.139.139,0,0,1-.155.036l-4.7-1.642a.763.763,0,0,0-.613.049,9.334,9.334,0,0,1-4.39,1.107h-.015A9.617,9.617,0,0,1,7.858,8.391a9.289,9.289,0,0,1,6.825-2.806,9.551,9.551,0,0,1,9.281,9.6,9.726,9.726,0,0,1-1.09,4.46.8.8,0,0,0-.048.623l1.617,4.78A.144.144,0,0,1,24.407,25.2Z",
    transform: "translate(0 -4.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M190.247,139.512H180.88a.786.786,0,0,0,0,1.572h9.367a.786.786,0,1,0,0-1.572Z",
    transform: "translate(-171.052 -132.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M190.247,202.183H180.88a.786.786,0,0,0,0,1.572h9.367a.786.786,0,1,0,0-1.572Z",
    transform: "translate(-171.052 -191.959)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M186.64,264.852h-5.761a.786.786,0,1,0,0,1.572h5.761a.786.786,0,0,0,0-1.572Z",
    transform: "translate(-171.004 -251.395)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon_message.1abe5e5ccaa9e0fd37ab8a85089f2b44.svg";
export { ForwardRef as ReactComponent };